import { Button } from 'components/atoms';
import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './Steps.scss';

export interface IStep<StepType extends string> {
  icon: ReactNode;
  name: StepType;
  error?: string;
}

interface IStepsProps<StepType extends string> {
  steps: IStep<StepType>[];
  activeStep: StepType;
  onClickStep: (step: StepType) => void;
  i18nPrefix: string;
  showErrors?: boolean;
}

const Steps = <StepType extends string>({
  steps,
  activeStep,
  onClickStep,
  i18nPrefix,
  showErrors,
}: IStepsProps<StepType>) => {
  const { t } = useTranslation();
  const activeStepIndex = useMemo(
    () => steps.findIndex(s => s.name === activeStep),
    [activeStep, steps]
  );
  return (
    <div className='steps'>
      {steps.map((step, index) => (
        <>
          <Button
            onlyIcon
            size='compact'
            onClick={() => onClickStep(step.name)}
            variant={
              showErrors && step.error?.length
                ? BUTTON_VARIANT.remove
                : index <= activeStepIndex
                ? BUTTON_VARIANT.submit
                : BUTTON_VARIANT.background
            }>
            <Button.Description
              description={
                step.error?.length
                  ? step.error
                  : t(`${i18nPrefix}${step.name}.name`)
              }
            />
            <Button.Icon icon={step.icon} />
            {/* <Button.Text text={`${index + 1}`} /> */}
          </Button>
          {index !== steps.length - 1 && (
            <div className='step-separator'>
              <span
                className={`${
                  index < activeStepIndex
                    ? 'submit'
                    : index === activeStepIndex
                    ? 'active'
                    : 'background'
                } ${
                  showErrors && step.error?.length ? 'step-separator-error' : ''
                }`}
              />
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default Steps;
